import type { H3Job } from "./h3Fleet";

// Badge variants for the states the fleet reports, shared by every panel that
// shows a worker or a clip so the same state never reads two ways.

export type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

/** Self-hosted worker states as the registry row reports them. */
export const STATE_VARIANT: Record<string, BadgeVariant> = {
  idle: "default",
  busy: "secondary",
  draining: "outline",
  blocked_gpu_busy: "outline",
  quarantined: "destructive",
  stale: "destructive",
  offline: "outline",
  /** In the window's history but no longer in the registry. */
  gone: "outline",
};

export const JOB_STATUS_VARIANT: Record<H3Job["status"], BadgeVariant> = {
  in_flight: "secondary",
  completed: "default",
  failed: "destructive",
  unsupervised: "outline",
  unknown: "outline",
};
